<template>
	<div>
		<el-dialog width="70%" :title="title==1?'公告':(title==2?'通知':'私信')" :before-close="handleClose" :close-on-click-modal="false"
		  :modal-append-to-body="false" :visible="isShow">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="未读" name="first"></el-tab-pane>
				<el-tab-pane label="已读" name="second"></el-tab-pane>
				<!-- <el-tab-pane label="待处理" name="third">待处理</el-tab-pane> -->
			</el-tabs>
			<el-table :data="formData" style="width: 100%">
				<el-table-column align="center" label="接收日期">
					<template slot-scope="scope">
						<i class="el-icon-time"></i>
						<span style="margin-left: 10px">{{ scope.row.createTime.split("T")[0] }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="sendName" label="发送者姓名">
				</el-table-column>
				<el-table-column align="center" prop="title" label="标题">
				</el-table-column>
				<el-table-column align="center" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
						<!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :current-page="formline.currentPage" @current-change="handleCurrentChange" style="margin: 20px;0"
			 background layout="total,prev, pager, next" :total="totalNum">
			</el-pagination>
		</el-dialog>
		<el-dialog title="" :visible.sync="isChildShow" :close-on-click-modal="false"  :modal-append-to-body="false">
			<el-form :model="receiveItems" label-width="75px">
				<el-form-item label="标题">
					<p  style="border: 1px solid #DCDFE6;padding: 10px;border-radius: 5px;">{{receiveItems.title}}</p>
				</el-form-item>
				<el-form-item label="消息内容">
					<p v-html="receiveItems.content" style="border: 1px solid #DCDFE6;padding: 10px;border-radius: 5px;"></p>
				</el-form-item>
				<el-form-item label="文件">
					<el-upload multiple action="/api/admin/bdContract/uploadContract" :on-preview="uploadDown" :headers="headers" :file-list="files"
					 name="file" disabled>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="isChildShow=false">确 定</el-button>
			</span>
		</el-dialog>


		<el-dialog title="提示" :visible.sync="dialogVisible" width="25%" :close-on-click-modal="false"  :modal-append-to-body="false">
			<span>确定下载该文件吗？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmDownload">已阅读</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import downloadFile from '../assets/js/downloadFile.js'

	export default {
		props: ["isShow", "title"],
		data() {
			return {
				headers: {
					Authorization: localStorage.access_token
				},
				isChildShow: false,
				activeName: 'first',
				formline: {
					currentPage: 1,
					pageSize: 10,
					status: 1
				},
				files: [],
				receiveItems: [],
				formData: [],
				totalNum: null,
				dialogVisible: false,
				obj: null,
			}
		},
		watch: {
			"title": function(val) {
				this.getMessage();
			}
		},
		mounted() {
			// this.getAll()
		},

		methods: {
			uploadDown(obj) {
				this.dialogVisible = true;
				this.obj = obj;
			},
			confirmDownload() {
				this.dialogVisible = false;
				downloadFile(this.obj);
			},


			handleClose() {
				this.$emit("isClose")
			},
			handleCurrentChange(num) { //当前页面变更
				this.formInline.currentPage = num;
				this.getAll();
			},
			handleClick(tab, event) {
				this.activeName == event.name
				this.getMessage();
			},
			// 查看
			handleEdit(a, b) {
				console.log(b)
				this.isChildShow = true
				this.receiveItems = b
				if (this.receiveItems.files != null) {
					let newFiles = [];
					this.receiveItems.files.forEach((item) => {
						newFiles.push({
							name: item.name,
							url: item.url
						});
					})
					this.files = newFiles;
				}

				this.read(b.id);
			},


			// 消息、公告
			getMessage() {
				let url;
				if (this.title == 2) {
					url = "/api/message/queryReceiverMessage";
				} else {
					url = "/api/notice/queryReceiverNotice";
				}
				if (this.activeName == "first") {
					this.formline.status = '1';
				} else {
					this.formline.status = '2';
				}
				this.$http.post(url, {
					...this.formline
				}).then(res => {
					if (res.data.code == 0) {
						this.formData = res.data.data.items
						this.totalNum = res.data.data.totalNum
					}
					console.log(res)
				}).catch(err => {
					console.log(err)
				})
			},
			//公告
			getNotice() {

			},

			// 阅读消息、公告
			read(id) {
				let url;
				if (this.title == 2) {
					url = "/api/message/readMessage";
				} else {
					url = "/api/notice/readWebNotice";
				}
				this.$http.get(url + `?id=${id}`).then(res => {
					this.getMessage();
					this.$parent.$parent.getSum();
				})
			},
		}
	}
</script>

<style scoped="scoped">
</style>
